import React from 'react';
import logo from '../../assets/imgs/liontaxi-transparent.png';

export const GlobalLoading = () => {
  return (
    <div>
      <span></span>
      <img src={logo} alt='Logo loading' />
    </div>
  );
};
